import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Button } from '../common/Button';
import { authApi } from '../../services/api';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    try {
      setLoading(true);
      await authApi.changePassword(currentPassword, newPassword, repeatNewPassword);
      setSuccess('Geslo je bilo uspešno spremenjeno.');
      setCurrentPassword('');
      setNewPassword('');
      setRepeatNewPassword('');
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Napaka pri spremembi gesla');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Spremeni geslo">
      <form onSubmit={handleSubmit} className="pnevmatika-form">
        {error && <div className="error-message" style={{ marginBottom: 12 }}>{error}</div>}
        {success && <div className="success-message" style={{ marginBottom: 12 }}>{success}</div>}
        <div className="form-group">
          <label htmlFor="currentPassword">Trenutno geslo</label>
          <input id="currentPassword" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} disabled={loading} />
        </div>
        <div className="form-group">
          <label htmlFor="newPassword">Novo geslo</label>
          <input id="newPassword" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} disabled={loading} />
        </div>
        <div className="form-group">
          <label htmlFor="repeatNewPassword">Ponovi novo geslo</label>
          <input id="repeatNewPassword" type="password" value={repeatNewPassword} onChange={(e) => setRepeatNewPassword(e.target.value)} disabled={loading} />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>Prekliči</Button>
          <Button type="submit" disabled={loading}>{loading ? 'Shranjujem...' : 'Shrani'}</Button>
        </div>
      </form>
    </Modal>
  );
};
